import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useReward } from 'react-rewards';
import { useSearchParams } from 'react-router-dom';

import { ReactComponent as Star } from '../../../assets/emojione_star.svg';
import { ReactComponent as NoOffer } from '../../../assets/No_offers_ui.svg';
import useAppConfig from '../../../hooks/useAppConfig';
import useAuth from '../../../hooks/useAuth';
import {
  getActivated,
  getActivationReady,
  getUrlOffer,
} from '../../../service/offer.service';
import IfEmpty from '../../../shared/constants/IfEmpty';
import STRING_CONSTANTS from '../../../shared/constants/StringConstants';
import {
  Active,
  ActiveBox,
  OfferCard,
  OfferCode,
  OnlyforYouBox,
  Textval,
} from '../../../styles/styledComponent';

const OFFER_CODE_PARAM = 'offerCode';

const ActivatedOffers = () => {
  const data = useAuth();
  const userToken = _.get(data, 'token', '');
  const { reward } = useReward('rewardContainer', 'confetti', {
    spread: 500,
    startVelocity: 30,
    elementCount: 80,
  });
  const [params, setParams] = useSearchParams();

  const [offerCode, setOfferCode] = useState(params.get(OFFER_CODE_PARAM));
  const [isMappingOffer, setIsMappingOffer] = useState(!!offerCode);
  const [offerMappingError, setOfferMappingError] = useState(null);

  const [activated, setActivated] = useState([]);
  const [activationReady, setActivationReady] = useState([]);
  const Config = useAppConfig();
  const Business = Config?.appConfig?.selecteBussines?.name;
  const getActivationReadyOffers = () => {
   Business && getActivated(Business).then((response) => setActivated(response || []));
   Business && getActivationReady(Business).then((response) =>
      setActivationReady(response || [...activationReady])
    );
  };

  useEffect(() => {
    const mapOffer = async () => {
      try {
        if (offerCode) {
          setIsMappingOffer(true);
          const payload = { offerCodes: [offerCode] };
          const data = await getUrlOffer(userToken, payload);
          if (data.isSuccess) {
            reward();
            setParams((params) => {
              params.delete('offerCode');
              return params;
            });
          } else {
            setOfferMappingError('Offer is invalid');
          }
        }
      } catch (err) {
        setOfferMappingError('Something went wrong');
      } finally {
        await getActivationReadyOffers();
        setIsMappingOffer(false);
      }
    };

    mapOffer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userToken, Business]);

  return (
    <div>
      {activated?.map((obj, index) => {
        return (
          <Card key={index}>
            {obj.currentOffer.isCustomerSpecific === true && (
              <Box className='display'>
                <Card>
                  <Box
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      marginLeft: 15,
                      marginTop: 5,
                    }}
                  >
                    <Star className='staricon' />
                    <Textval>{STRING_CONSTANTS.ONLY_FOR_YOU}</Textval>
                  </Box>
                </Card>
              </Box>
            )}
            {/* <Box className="display"> */}
            <Typography
              style={{ fontSize: 14, fontWeight: 600, marginBottom: 5 }}
            >
              Offer Name:{' '}
              {obj?.currentOffer?.categoryInfo?.category
                ? obj.currentOffer.categoryInfo.category
                : '--'}
            </Typography>
            <Typography style={{ fontSize: 14, marginBottom: 10 }}>
              <b> {STRING_CONSTANTS.VALID_TILL}: </b>
              {moment(
                `${_.get(obj, 'expiresOn', 'currentOffer.endDate')}`
              ).format('DD-MM-YYYY')}
            </Typography>
            {/* </Box> */}
            <Typography style={{ fontSize: 14, marginBottom: 10 }}>
              <span style={{ fontWeight: 600 }}> Offer Description: </span>
              {obj?.currentOffer?.description}
            </Typography>
            <Box className='display'>
              <OfferCode>
                {STRING_CONSTANTS.OFFER_CODE} {obj?.offerCode}
              </OfferCode>
              <ActiveBox>
                <Active>{STRING_CONSTANTS.ACTIVE}</Active>
              </ActiveBox>
            </Box>
          </Card>
        );
      })}

      {activationReady?.map((obj, index) => {
        return (
          <OfferCard key={index}>
            {obj.currentOffer.isCustomerSpecific === true && (
              <Box className='display'>
                <OnlyforYouBox>
                  <Box
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      marginTop: 5,
                      marginLeft: 15,
                    }}
                  >
                    <Star className='staricon' />
                    <Textval>{STRING_CONSTANTS.ONLY_FOR_YOU}</Textval>
                  </Box>
                </OnlyforYouBox>
              </Box>
            )}
            {/* <Box className="display"> */}
            <Typography
              style={{ fontSize: 14, fontWeight: 600, marginBottom: 10 }}
            >
              Offer Code: <code>{obj?.offerCode}</code>
            </Typography>
            <Typography style={{ fontSize: 14, marginBottom: 10 }}>
              <b> {STRING_CONSTANTS.VALID_TILL} </b>
              {moment(
                `${_.get(obj, 'expiresOn', 'currentOffer.endDate')}`
              ).format('DD-MM-YYYY')}
            </Typography>
            {/* </Box> */}

            <Typography style={{ fontSize: 14, marginBottom: 0 }}>
              <span style={{ fontWeight: 600 }}> Offer Description: </span>
              {obj?.currentOffer?.description}
            </Typography>
          </OfferCard>
        );
      })}

      {activated?.length === 0 && activationReady?.length === 0 && (
        <IfEmpty
          Icon={NoOffer}
          head={STRING_CONSTANTS.EMPTY}
          desc={STRING_CONSTANTS.NO_OFFERS_FOUND}
        />
      )}
      <Dialog open={!!offerCode} fullWidth maxWidth='xs'>
        <DialogTitle fontSize={16} fontWeight={600} lineHeight={1.2}>
          Unlock Rewards
        </DialogTitle>

        <DialogContent dividers>
          {isMappingOffer && !offerMappingError && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                gap: '1.5rem',
                padding: '2rem',
              }}
            >
              <Typography>Unlocking rewards — Just a moment!</Typography>
              <CircularProgress color='primary' size={18} />
            </Box>
          )}
          <span
            id='rewardContainer'
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          />
          {!isMappingOffer && offerMappingError && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                gap: '1.5rem',
                padding: '2rem',
              }}
            >
              <Typography>Oops! Something was wrong</Typography>
              <Typography color='error.main' variant='body1' align='center'>
                {offerMappingError}
              </Typography>
            </Box>
          )}
          {!isMappingOffer && !offerMappingError && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                gap: '1rem',
              }}
            >
              <Typography variant='body1' align='center'>
                You’ve successfully unlocked:
              </Typography>
              <Box
                sx={{
                  background: '#f3f3f3',
                  padding: '1rem',
                  width: '100%',
                  textAlign: 'center',
                  borderRadius: '.5rem',
                }}
              >
                <code>CODE: {offerCode}</code>
              </Box>
              <Typography variant='body2' color='text.secondary' align='center'>
                Enjoy your reward and make the most of it!
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            color='primary'
            disabled={isMappingOffer}
            onClick={setOfferCode.bind(null, null)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ActivatedOffers;
